// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */[data-v-17f44c72] .wrapper{margin-top:-3.2rem;margin-bottom:3.2rem}@media (max-width:767px){[data-v-17f44c72] .wrapper{margin-top:-1.6rem;margin-bottom:2.4rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
